module.exports = __webpack_public_path__ + "a9f87cb050904174e16f7f40ac96e01c.fbx";